const AvailableBalance = ({ initialBalance = 0 }) => {
  const formattedBalance = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(initialBalance));

  return (
    <div className="w-fit flex flex-col gap-2 px-8 py-5 justify-start items-start bg-primary/60 border-2 border-dashed border-primary rounded-3xl">
      <h2 className="text-subtitle2 font-nunito font-bold text-secondary/70">
        Available Balance
      </h2>
      <span className="text-headline3 font-nunito font-bold text-secondary items-start">
        {formattedBalance}
      </span>
    </div>
  );
};

export default AvailableBalance;
